import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { Reveal } from '../Reveal';
const secondaryStats = [{
  value: '2',
  label: 'Offices open — Bengaluru & Chennai'
}, {
  value: '7',
  label: 'Cities planned by 2028'
}, {
  value: 'Fee-only',
  label: 'No commissions, ever'
}];
export function TrustBar() {
  return <section className="border-b border-line bg-cream" aria-label="Firm at a glance" data-id="element-151" data-mp="1fe1yfu8vbtnm">
      
    </section>;
}